module.exports = __webpack_public_path__ + "static/media/1POLICY3.b9bbd144.jpg";